import React, { useEffect } from "react";
// Common components
import { Form, Button } from "src/Components";
// requests
import {
  getMainInstrumentConfig,
  setMainInstrumentConfig,
} from "src/Requests/fundNoRiskTask";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
import MultiSelectDropdownWithBox from "src/Components/Dropdown/MultiSelectDropdownWithBox";

import { getStepInstruments } from "src/Requests/stepRequests";
import { OptionType } from "src/Components/Dropdown/StaticDropdown";
import { StepInstrumentType } from "src/Interfaces/stepInterfaces";
import { toast } from "react-toastify";

interface Props {
  onSuccess: () => void;
  onClose: () => void;
}
const SandooghModal: React.FC<Props> = (props) => {
  const [instrumentIds, setInstrumentIds] = React.useState<string[]>([]);
  const [options, setOptions] = React.useState<OptionType[]>([]);

  useEffect(() => {
    getStepInstruments()
      .then((instruments) => {
        const mappedOptions = instruments.map(
          (instrument) =>
            ({
              value: instrument.id.toString(),
              label: instrument.name,
            }) as OptionType,
        );
        setOptions(mappedOptions);
      })
      .catch(packetErrorHandler);

    getMainInstrumentConfig()
      .then((config) => setInstrumentIds(config.instrumentIds ?? []))
      .catch(packetErrorHandler);
  }, []);

  const clickHandler = () => {
    setMainInstrumentConfig(instrumentIds)
      .then((r) => {
        if (r.data) {
          toast.success(r.msg);
          props.onSuccess();
          props.onClose();
        } else {
          toast.error(r.msg);
        }
      })
      .catch(packetErrorHandler);
  };

  const handleChange = (value: string[] | null | undefined) => {
    if (value) setInstrumentIds(value);
    else setInstrumentIds([]);
  };

  return (
    <Form className="!w-80 gap-3 p-2 px-2 !mx-auto">
      <div className="text-sm font-semibold whitespace-nowrap w-auto">
        نمادهای غیر درآمد ثابت
      </div>
      <div className="text-[10px] whitespace-nowrap w-auto">نام نماد</div>
      <div className="relative w-full">
        <MultiSelectDropdownWithBox
          handleChange={handleChange}
          valueList={instrumentIds}
          options={options}
        />
      </div>
      <Button
        text="ثبت"
        onClick={clickHandler}
        variant="contained"
      />
    </Form>
  );
};

export default SandooghModal;
